import React from "react";
import { CameraIcon, ClipboardCheckIcon, FileTextIcon, MapIcon, TableIcon } from "lucide-react";
import { ToolIcon, tools } from "../../data/content";
import { CTAButton } from "../CTAButton";
const iconMap: Record<ToolIcon, React.ElementType> = {
  sheet: FileTextIcon,
  checklist: ClipboardCheckIcon,
  map: MapIcon,
  matrix: TableIcon,
  camera: CameraIcon
};
export function Tools() {
  return <section className="bg-navy px-4 py-16 text-white" data-id="element-289" data-mp="28jmpc1kgn7kg">
      <div className="mx-auto max-w-3xl" data-id="element-290" data-mp="28l6aa5h2a6sk">
        <p className="text-center text-[13px] font-bold uppercase tracking-wider text-gold" data-id="element-291" data-mp="23sd73m18r6il">Plus</p>
        <h2 className="mt-2 text-center font-serif text-[30px] font-bold leading-tight sm:text-4xl" data-id="element-292" data-mp="1yss1wtvha1xf">
          You’ll also receive access to these review tools
        </h2>
        <ul className="mt-8 divide-y divide-white/10 rounded-3xl bg-white/[0.05]" data-id="element-293" data-mp="1pslw7u60u68t">
          {tools.map(t => {
          const Icon = iconMap[t.icon];
          return <li key={t.title} className="flex gap-4 p-5" data-id="element-294" data-mp="1kw4we2pgm3fw">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-gold text-ink" data-id="element-295" data-mp="158obaeam79sy">
                  <Icon className="h-5 w-5" aria-hidden data-id="element-296" data-mp="1a1hfn1268g4i" />
                </span>
                <div data-id="element-297" data-mp="wa2sqj557us6">
                  <h3 className="text-[17px] font-bold leading-snug text-goldsoft" data-id="element-298" data-mp="wama9yqvsh5o">{t.title}</h3>
                  <p className="mt-1 text-[15px] leading-snug text-white/80" data-id="element-299" data-mp="10amqnoxjj2fd">{t.desc}</p>
                </div>
              </li>;
        })}
        </ul>
        <p className="mt-6 text-center text-[16px] font-semibold text-white/90" data-id="element-300" data-mp="1sxzd7z3pba8o">
          Everything is designed to be downloaded, printed and reused.
        </p>
        <CTAButton className="mt-8" label="I want access to the complete system" data-id="element-301" data-mp="1jycejl2cwijb" />
      </div>
    </section>;
}